import { useState } from "react";

export default function Demo() {
  const [count, setCount] = useState(0);

  return (
    <div className="card bg-base-100 p-5">
      <p className="text-base-content/70 mb-3">React 19 + TypeScript widget</p>
      <p className="text-2xl font-semibold mb-4">Count: {count}</p>
      <div className="flex gap-2">
        <button className="btn btn-primary btn-sm" onClick={() => setCount(count + 1)}>
          +1
        </button>
        <button className="btn btn-ghost btn-sm" onClick={() => setCount(0)}>
          reset
        </button>
      </div>
    </div>
  );
}
